<template>
    <v-container  fluid fill-height class="email-sent mt-5">
        <v-layout flex align-center justify-center>
            <div class="text-xs-center mt-4">
                <v-icon x-large dark color="info" style="font-size: 8em">mdi-telegram</v-icon>
                <h2 class="font-weight-bold mt-3">ระบบส่ง Email ให้เรียบร้อยแล้ว</h2>

                <v-btn color="info" large dark block class="font-weight-bold mt-4" @click="back_to_emp()">กลับไปหน้าค้นหาพนักงาน</v-btn>

            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "EvaEmailSent",
        methods:{
            back_to_emp(){
                this.$emit('back_to_emp')
            }
        }
    }
</script>

<style scoped>

</style>